const debug = false
// const debug = "canEditEvent"

module.exports = {
    canEditEvent(event) {
        if (!event) return false

        // const cId =     event.companyId         ? event.companyId           : (event.company && event.company.id)               ? event.company.id          : null;
        const pId =     event.projectId         ? event.projectId           : (event.project && event.project.id)               ? event.project.id          : null;
        let uId =       event.userId            ? event.userId              : (event.user && event.user.id)                     ? event.user.id             : null;
        if (!uId) uId = event.assignedToUserId  ? event.assignedToUserId    : (event.assignedToUser && event.assignedToUser.id) ? event.assignedToUser.id   : null;

        // const companyUser = gd.session.companyUsers.findByCompanyAndUser(cId, gd.session.me.id);

        let result = false;

        if (event.type <= 5)                                                { result = uId === gd.session.me.id /*assigned to cur user*/ || gd.ac.check.project.fullAccess(pId) /*full project access*/} //project event
        else if (/*companyUser &&*/ gd.ac.check.company.isManager())        { result = true}
        else if (event.type >= 20 && event.type <= 25)                      { result = gd.session.me.id === uId;}                                       // Personal event
        else if ([gd.const.event.type.TASK_DEADLINE].includes(event.type))  { result = gd.ac.check.task.editDeadline(event.task.projectId, event.task)} // Task deadline
        else if ([gd.const.event.type.TASK_SCHEDULE].includes(event.type))  { result = gd.ac.check.task.editSchedule(event.task.projectId, event.task)} // Task schedule
        else if ([gd.const.event.type.TASK_START_END].includes(event.type)) { result = gd.ac.check.task.editStartEnd(event.task.projectId, event.task)} // Task start/end
        else if ([gd.const.event.type.MEETING].includes(event.type))        { result = event.meeting.role === gd.const.meeting.role.ORGANIZER}          // MEETING event

        debug && console.log(debug, 'process', result, gd.ac.check.project.fullAccess(pId), pId, event)

        return result;
    }
};